export default "__VITE_ASSET__Cyfp$UD___"